<template>
    <div>
        
        <div v-if="item" class="recom-list" @click="godetail(item)">
            <recommendhead :item="item" @Attention="Attention"></recommendhead>
            <div class="recom-content">
                
                <div class="recom-content-tit">
                    {{item.content}}
                </div>
                <div class="recom-content-all" v-if="showallwz">
                    全文
                </div>
                <div class="recom-content-imgs" @click.stop="showimage(item)" v-if="item.topicImgs&&item.topicImgs.length>0">
                    <div v-if="item.topicImgs.length>1">
                        <div v-for="(imgitem,index) in item.topicImgs" class="recom-content-fimg"   :key="index">
                            <div class="recom-content-img" v-if="index<showonly">
                                <img :src="$baseurl+imgitem.pathImg" v-if="index<showonly"/>
                                <div >

                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-if="item.topicImgs.length==1">
                        <div  class="recom-content-oneimg">
                            <img :src="$baseurl+item.topicImgs[0].pathImg"  />
                        </div>
                    </div>
                    
                </div>
                <div class="recom-heads-imgs" v-if="showheads">
                    <div class="recom-heads-imgs-left">
                        <div class="recom-heads-img">
                            <img src="https://img01.yzcdn.cn/vant/cat.jpeg" />
                        </div>
                        <div class="recom-heads-img">
                            <img src="https://img01.yzcdn.cn/vant/cat.jpeg" />
                        </div>
                        <div class="recom-heads-img">
                            <img src="https://img01.yzcdn.cn/vant/cat.jpeg" />
                        </div>
                        <div class="recom-heads-img">
                            <img src="https://img01.yzcdn.cn/vant/cat.jpeg" />
                        </div>
                    </div>
                    <div class="recom-heads-imgs-right">
                        <span>29赞</span>
                        <van-icon class="recom-heads-imgs-right-icon" name="arrow" :size="12"  />
                    </div>
                </div>
                
                <!-- <div class="recom-content-imgs">
                    <div class="recom-content-oneimg">
                            <img src="https://img01.yzcdn.cn/vant/cat.jpeg" />
                    </div>
                </div> -->
                 <div class="recom-icons" v-if="showalloperate">
                    <div class="recom-icon" @click="godetail(item)">
                        <van-icon
                            class="recom-icon-icon2"
                            :size="18"
                            
                            class-prefix="abc-icon"
                            name="pinglun8"
                        />
                        <span>{{item.commentCount}}</span>
                    </div>
                    <div class="recom-icon" @click.stop="like(item)">
                        <van-icon
                            class="recom-icon-icon3"
                            :size="18"
                            name="like-o"
                            v-if="!item.isLike"
                        />
                         <van-icon
                            class="recom-icon-icon3"
                            :size="18"
                            name="like"
                            v-if="item.isLike"
                            color="red"
                        />
                        <span>{{item.giveLikeCount}}</span>
                    </div>
                </div>
            </div>
        </div>
        <van-image-preview v-model="imageshow" :images="images">
                <!-- <template v-slot:index>第{{ index }}页</template> -->
        </van-image-preview>
    </div>
</template>
<script>
import alloperate from '@/components/common/recommend/alloperate';
import recommendhead from '@/components/common/recommend/recommendhead.vue';
export default {
    components:{
        alloperate,
        recommendhead
    },
    props:{
        item:{
            type:Object,
            default:undefined
        },
        showalloperate:{
            type:Boolean,
            default:true
        },
        showonly:{
            type:Number,
            default:3
        },
        showallwz:{
            type:Boolean,
            default:false
        },
        showheads:{
            type:Boolean,
            default:false
        }
    },
    name:'comrecommend',
    data(){
        return{
            imageshow:false,
            images:[]
        }
    },
    created(){

    },
    methods:{
        Attention(item)
        {
            this.$emit('Attention',item);
        },
        godetail(item){
            var itemjson=JSON.stringify(item);
            this.$router.push({path:'/recommenddetail',query:{item:itemjson}});
        },
        like(item)
        {
            this.$emit('like',item);
        },
        showimage(item)
        {
            var imgs= item.topicImgs.map(x=>
            {
                return this.$baseurl+x.pathImg;
            })
            this.images=imgs;
            this.imageshow=true;
        }
    }
}
</script>
<style lang="scss" scoped>
.recom-list{
    padding: 8px 18px;
    background-color: #fff;
    margin-top:10px;
    font-size: 15px;
    text-align: left;
    line-height: 22px;
    
    
    
    .recom-content-all{
        color:#125caa;
        font-weight: bold;
    }

    .recom-content-tit{
        word-break: break-all;
        display: -webkit-box;
        overflow: hidden;
        text-overflow: ellipsis;
        -webkit-line-clamp: 5;
        -webkit-box-orient: vertical;
        margin-bottom: 5px;
    }

    .recom-content-imgs{
        margin-bottom: 5px;
        text-align: left;
        .recom-content-fimg{
            display: inline-block;
             .recom-content-img{
                display: inline-block;
                margin-right: 5px;
                width: 28vw;
                height: 28vw;
                margin-bottom: 5px;
                img{
                    border-radius: 4px;
                    width: 100%;
                    height: 100%;
                }
            }
            
        }
       
        .recom-content-oneimg{
            img{
                border-radius: 4px;
                max-width:100%;
                height: auto;
            }
        }
    }

    .recom-heads-imgs{
        margin-top: 10px;
        display: flex;
        flex: 1;
    }
    .recom-heads-imgs-left{
        width: 80%;
        display: flex;
        .recom-heads-img{
            img{
                margin-left: -4px;
                width: 24px;
                height: 24px;
                padding: 2px;
                border-radius: 50%;
                background-color: #fff;
            }
        }
       
    }
    .recom-heads-imgs-right{
        width: 20%;
        line-height: 28px;
        color:#a8a8a8;
        font-size: 12px;
        text-align: right;
        .recom-heads-imgs-right-icon{
            margin-left: 5px;
            vertical-align: -2px;
        }
    }


    .recom-icons{
    display: flex;
    text-align: center;
    line-height: 25px;
    .recom-icon{
        width: 50%;
    }
    .recom-icon-icon1{
        vertical-align: -2px;
        margin-right: 2px;
    }
    .recom-icon-icon2{
        vertical-align: -1px;
        margin-right: 4px;
    }
    .recom-icon-icon3{
        vertical-align: -3px;
        margin-right: 4px;
    }
}

}
</style>